import React from "react";
import { useTranslation } from "react-i18next";
import "./benefits.scss";

function Benefits() {
  const { t } = useTranslation()
  
  return (
    <div className="container-benefits">
      <div className="texts-benefits">
        <h1>{t("data_management.datasource.title")}</h1>
        <p>{t("data_management.datasource.section_text_1")}</p>
        <p>{t("data_management.datasource.section_text_2")}</p>
      </div>
    </div>
  );
}

export default Benefits;
